export enum DashboardType {
  Banking,
  Dashboard,
}
